<div class="inline-date-picker-wrapper">
  @if (!isEditing) {
    <span class="left">
      @if (!value) {
        <a (click)="toggleEdit()" class="add-date"> Add date </a>
      }
      @if (value) {
        <span>
          {{ formattedDate }}
        </span>
      }
      @if (value) {
        <button class="edit-button" mat-icon-button (click)="toggleEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing
    }"
    >
    <form>
      <mat-form-field appearance="outline">
        <mat-label>Choose a date</mat-label>
        <input
          matInput
          (click)="datePicker.open()"
          [matDatepicker]="datePicker"
          [formControl]="date"
          [min]="minimum | startOfDay"
          [required]="required"
          />
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker> </mat-datepicker>
      </mat-form-field>
    </form>
    <div class="button-container">
      <button mat-button (click)="toggleEdit()">CANCEL</button>
      <button mat-button class="save" [disabled]="required && !date.value" (click)="onSave()">SAVE</button>
    </div>
  </div>
</div>
